import { css } from '@emotion/react';

import theme from 'shared/styles/themes';

export const classes = {
  moduleReview: 'module-review',
  reviewButtons: 'module-review__buttons',
  copyLinkButton: 'module-review__copy-link-button',
};

export const moduleReviewStyles = ({
  margin = theme.space[4],
  alignItems = 'center',
}: {
  margin: string;
  alignItems: string;
}) => css`
  &.${classes.moduleReview} {
    margin: ${margin};
  }
  .${classes.reviewButtons} {
    display: flex;
    align-items: ${alignItems};
    width: 'fit-content';
  }
  .${classes.reviewButtons} .action-button {
    padding: 0.2rem ${theme.space[5]};
  }
  .${classes.copyLinkButton} {
    margin-right: ${theme.space[3]};
  }
`;

export const moduleReviewContentStyles = css`
  .lightbox__content {
    &__item {
      justify-content: center;
    }
  }
`;
